/**
 * Cómo salió la prueba del asistente: el título y el tono salen de `tituloPrueba` (logic/chequeo.ts), que nunca dice
 * «Mandada» por un 200 a secas. Pasado el minuto sin un estado final, «Volver a consultar».
 */
import { CheckCircle2, FlaskConical, Loader2, OctagonAlert, RefreshCw } from "lucide-react";
import type { PlantillaDetalle } from "../../types";
import { conEjemplos, desdeDetalle } from "../../logic/plantilla";
import { usd } from "../../logic/formato";
import { PreviaWhatsApp } from "../PreviaWhatsApp";

const TONO_PRUEBA: Record<"ok" | "espera" | "error" | "simulado", { cls: string; icono: JSX.Element }> = {
  ok: { cls: "border-emerald-200 bg-emerald-50 text-emerald-800", icono: <CheckCircle2 size={16} /> },
  simulado: { cls: "border-amber-200 bg-amber-50 text-amber-800", icono: <FlaskConical size={16} /> },
  espera: { cls: "border-amber-200 bg-amber-50 text-amber-800", icono: <Loader2 size={16} className="animate-spin" /> },
  error: { cls: "border-red-200 bg-red-50 text-red-700", icono: <OctagonAlert size={16} /> },
};

export function TarjetaPrueba({ titulo, estadoLabel, costoReservadoUSD, texto, previa, consultando, vencida, pollDetenido, onReconsultar }: {
  titulo: { titulo: string; tono: "ok" | "espera" | "error" | "simulado" }; estadoLabel: string; costoReservadoUSD: number;
  texto: string; previa?: PlantillaDetalle; consultando: boolean; vencida: boolean; pollDetenido: boolean; onReconsultar: () => void;
}) {
  const t = TONO_PRUEBA[titulo.tono];
  const b = previa ? desdeDetalle(previa) : null;
  return (
    <div className={`rounded-xl border p-4 space-y-3 ${t.cls}`} data-testid="tarjeta-prueba" role="status">
      <p className="flex items-center gap-2 text-sm font-semibold">{t.icono} {titulo.titulo}</p>
      <p className="text-xs">
        Estado: {estadoLabel}. Costo reservado: {usd(costoReservadoUSD, 4)}.
        {consultando && " Consultando el estado…"}
        {/* un borrador no tiene bitácora: el estado se vuelve a pedir acá */}
        {vencida && " Pasó un minuto sin confirmación: puede llegar más tarde. Mirá tu teléfono o volvé a consultar."}
        {pollDetenido && " Dejamos de consultar porque el servidor no responde."}
      </p>
      {(vencida || pollDetenido) && (
        <button type="button" onClick={onReconsultar}
          className="inline-flex min-h-[44px] items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 text-xs font-semibold text-slate-700 hover:bg-slate-50">
          <RefreshCw size={13} aria-hidden="true" /> Volver a consultar
        </button>
      )}
      {texto && (
        <PreviaWhatsApp compacto texto={texto} mediaUrl={b?.mediaUrl ? conEjemplos(b.mediaUrl, b) : undefined} botones={b?.botones || []}
          pie={b?.tipo === "whatsapp/card" ? b.pie : undefined} encabezadoTexto={b?.encabezadoTexto} />
      )}
    </div>
  );
}
